// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ZozZaWr_PVKPQ98jGy5p {
  font-size: 16px;
  font-weight: 540;
  margin-bottom: 5px;
  color: rgb(var(--placeholder-primary));
}

.q2TYVqq7dOP2TqCU1f8I {
  border-radius: 24px;
  padding: 16px;
  background: rgba(var(--secondary-bg), 0.40);
  margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/apps/all-apps/all-apps.module.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;AACpB","sourcesContent":["\n.allAppsTitle {\n  font-size: 16px;\n  font-weight: 540;\n  margin-bottom: 5px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.allApps {\n  border-radius: 24px;\n  padding: 16px;\n  background: rgba(var(--secondary-bg), 0.40);\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allAppsTitle": `ZozZaWr_PVKPQ98jGy5p`,
	"allApps": `q2TYVqq7dOP2TqCU1f8I`
};
export default ___CSS_LOADER_EXPORT___;
